import Routing from "fos-router";import routes from "/var/www/my-preprod/php82/clientmydeed/srcs/public/assets/routes.json";Routing.setRoutingData(routes);